module.exports = __webpack_public_path__ + "img/loading-night.614c4dad.jpg";